import * as React from "react";
import { Box } from '@mui/material';
import { theme } from 'config';
import styled from 'styled-components';
import { Icon, IconSize } from './icon'
import { BoxProps } from "@mui/material/Box";

export interface ICheckmarkProps {
  variant?:   'failure' | 'success' | 'unchecked',
  height?:    string,
  width?:     string,
  checkSize?: IconSize,
  inverted?:  boolean,
  boxProps?:  BoxProps,
}

export const CheckmarkCircle = (props: ICheckmarkProps) => {
  const {variant, height, width, checkSize, inverted, boxProps } = props;

  const color_success = theme.palette.lightGreen.main;
  const color_failure = theme.palette.error.main;
  const color_neutral = 'white';

  return (
    <Circle
      height        = {height  || "2rem"}
      width         = {width   || "2rem"}
      variant       = {variant || 'success'}
      inverted      = {inverted || false}
      color_success = {color_success}
      color_failure = {color_failure}
      color_neutral = {color_neutral}
      {...(boxProps || {} as any) }
    >
      {variant !== 'unchecked' && 
        <Icon size={checkSize || 'size-20'} iconId={variant === 'failure' ? 'remove' :'checkmark'} />
      }
    </Circle>
  )
}

const Circle = styled(Box)<{
  variant?: 'failure' | 'success' | 'unchecked',
  height?:  string,
  width?:   string,
  inverted: boolean,
  color_success: string,
  color_failure: string,
  color_neutral: string,
}>`
  display:          flex;
  align-items:      center;
  justify-content:  center;
  height:           ${(p) => p.height};
  width:            ${(p) => p.width};
  border-radius:    50%;
  border:           1.5px solid;
  color:            ${p => p.inverted
    ? (p.variant === 'failure' ? p.color_failure : p.color_success)
    : p.color_neutral
  };
  border-color: ${p => p.variant === 'unchecked'
    ? p.color_neutral
    : (p.inverted 
      ? p.color_neutral
      : (
        p.variant === 'success' 
          ? p.color_success
          : p.color_failure
      )
    )
  };
  background-color: ${p => p.variant === 'unchecked'
    ? undefined
    : (p.inverted 
      ? p.color_neutral
      : (
        p.variant === 'success' 
          ? p.color_success
          : p.color_failure
      )
    )
  };
`
